import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDrillingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "drilling-sm" }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [
			/* @__PURE__ */ _jsx("polygon", {
				className: "icon-white",
				points: "54.75 32.64 53.38 27.27 8.56 53.67 8.56 65.59 50.13 89.59 91.44 65.74 91.44 53.82 54.75 32.64"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92,52.78l-38.16-22v2.77L89,53.82,50.13,76.28,11,53.67,46.37,33.22V30.45L8,52.63a1.2,1.2,0,0,0-.6,1V65.59a1.2,1.2,0,0,0,.6,1l41.57,24a1.21,1.21,0,0,0,1.2,0L92,66.78a1.2,1.2,0,0,0,.6-1V53.82A1.2,1.2,0,0,0,92,52.78Zm-1.8,3.12v9.15L51.33,87.51V78.36ZM48.93,78.36v9.15L9.76,64.9V55.75Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M45.9,8.17a1,1,0,0,0,1-1V5.29a1,1,0,1,0-1.92,0V7.21A1,1,0,0,0,45.9,8.17Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M45.9,24.38a1,1,0,0,0,1-1V19.37a1,1,0,1,0-1.92,0v4.05A1,1,0,0,0,45.9,24.38Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M45.9,16.27a1,1,0,0,0,1-1V11.26a1,1,0,0,0-1.92,0v4.05A1,1,0,0,0,45.9,16.27Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M54.36,10.3a1,1,0,0,0-1,1v4.05a1,1,0,0,0,1.92,0V11.26A1,1,0,0,0,54.36,10.3Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M54.4,27.93a3.14,3.14,0,0,0,.53-.74,2.22,2.22,0,0,0,.39-1.39V19.37a1,1,0,0,0-1.92,0v1.81l-5.9,5.64a1.16,1.16,0,0,1-.24-.2,1,1,0,0,0-.67-.29,1.06,1.06,0,0,0-.68.27,1,1,0,0,0,0,1.36L46,28a3.52,3.52,0,0,0-.79,1.21,2.51,2.51,0,0,0-.22,1.1V40.1a3.33,3.33,0,0,0,1,2.4,3.35,3.35,0,0,0-.39.47,2.09,2.09,0,0,0-.62,1.66v9.95a3.35,3.35,0,0,0,1,2.36l-.35.33a2.07,2.07,0,0,0-.62,1.66v1.14a1,1,0,0,0,.48.83l4.13,2.39a1,1,0,0,0,.48.13,1,1,0,0,0,.48-.13l4.33-2.5a1,1,0,0,0,.48-.83v-.57a3.33,3.33,0,0,0-1-2.4,3.37,3.37,0,0,0,1-2.41V44.91a3.37,3.37,0,0,0-1-2.41,3.3,3.3,0,0,0,1-1.82.59.59,0,0,0,0-.14,3.15,3.15,0,0,0,0-.44V30.43a3.35,3.35,0,0,0-1-2.41l.06-.05ZM52.57,58.09a1.44,1.44,0,0,1,.83,1.3l-3.37,2L49.48,61Zm-5.71-18V34.94l5.94-5.68a1.44,1.44,0,0,1,.6,1.17v5l-6,5.74A1.4,1.4,0,0,1,46.86,40.1Zm0,9.14,5.83-5.57a1.44,1.44,0,0,1,.71,1.24v4.87l-6.1,5.83a1.38,1.38,0,0,1-.44-1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M54.36,4.33a1,1,0,0,0-1,1V7.21a1,1,0,0,0,1.92,0V5.29A1,1,0,0,0,54.36,4.33Z"
			})
		]
	})]
});
export default SvgDrillingSm;
